<template>
  <v-dialog
    v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template v-slot:activator="{ on }">
      <v-list-item v-if="inMenu" v-on="on">Delete</v-list-item>

      <v-btn v-else icon small v-on="on">
        <v-icon color="primary">mdi-trash-can-outline</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>Please Confirm</v-card-title>
     
      <v-divider />
     
      <v-card-text class="py-2">
        Are you sure you want to delete this device?
      </v-card-text>

      <v-divider />

      <v-card-actions class="justify-center py-4">
        <v-btn color="primary" @click="close">Cancel</v-btn>
        <v-btn @click="deleteClick">Delete</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import { mapActions }  from 'vuex'

export default {
  name: 'DeviceDeleteDialog',

  props: {
    device: Object,
    inMenu: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    dialogVisible: false,
  }),

  methods: {
    ...mapActions('devices', ['deleteDevice']),

    close() {
      this.dialogVisible = false
      this.$emit('close')
    },

    async deleteClick() {
      const { device_id } = this.device

      this.loading = true
      const result = await this.deleteDevice({ device_id })
      this.loading = false

      if (result.ok) {
        this.$emit('reload')
      } else {
        this.$emit('error', result.error)
      }

      this.close()
    },
  },
}
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }
</style>